import type { Event } from '@sentry/react'

import { normalizePathname } from '~/utils/observability/tracking/utils/normalizePathname'

/**
 * Groups `httpClientIntegration` events into one Sentry issue per method, endpoint and status.
 *
 * Such an event carries only the method, URL and status of a failed request. Without a fingerprint, Sentry groups
 * it by the stack captured at the `fetch` call, and TanStack Query calls `fetch` again from its retry timer, so
 * every attempt of one failed request would open its own issue.
 */
export function groupHttpClientError<T extends Event>(event: T): T {
    const url = event.request?.url
    if (event.exception?.values?.[0]?.mechanism?.type !== 'http.client' || !url) {
        return event
    }

    const method = event.request?.method ?? 'GET'
    const status = String(event.contexts?.response?.status_code ?? 'unknown')

    return { ...event, fingerprint: ['http.client', method, normalizePathname(url), status] }
}
